import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hook";
import {
  CAMERA_GET_ALL,
  CAMERA_ADD,
  CAMERA_DELETE,
} from "src/store/camera/action";
import {
  getAllCamera,
  createCamera,
  deleteCameraApi,
} from "src/services/cameraServices";

function useCamera() {
  const { cameras } = useAppSelector((state) => state.camera);
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  const fetchCameras = async () => {
    try {
      setLoading(true);
      const response = await getAllCamera("CAMERA", 0, 6);
      dispatch(CAMERA_GET_ALL({ cameras: response.data }));
    } catch (error) {
      console.error("Error fetching cameras:", error);
    } finally {
      setLoading(false);
    }
  };

  const addCamera = async (cameraData) => {
    try {
      const response = await createCamera(cameraData);
      dispatch(CAMERA_ADD({ camera: response.data }));
      await fetchCameras();
    } catch (error) {
      console.error("Error adding camera:", error);
    }
  };

  const removeCamera = async (cameraId) => {
    try {
      await deleteCameraApi(cameraId);
      dispatch(CAMERA_DELETE({ cameraId }));
      await fetchCameras();
    } catch (error) {
      console.error("Error deleting camera:", error);
    }
  };

  return {
    cameras,
    isLoading,
    addCamera,
    removeCamera,
    fetchCameras
  };
}

export default useCamera;
